function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M453.9 382.7c-51.8-8-54.9-12.7-54.9-12.7 15.6-74-23.2-154.1-77.1-198.6C250.1 112.2 141 155.2 56 65.2c-.8-.8-1.5-1.2-2.2-1.2-16.6 0-2 240.5 100.3 333.9C196.9 437.1 244 448 281.8 448c30.8 0 55.5-7.3 66.8-12.5 22.8-10.6 38.7-33.9 38.7-33.9 37 11.6 57.3 12.2 61.3 12.2h.7c.4.1.8.1 1.2.1 13.8 0 20.3-28.6 3.4-31.2zm-112 38.3c-8.9 4.1-31.5 11-60 11-19.6 0-38.7-3.2-56.7-9.5-21.9-7.6-42.1-19.9-60.2-36.4-20.4-18.6-38.6-45.2-54-79-13.3-29-24.3-62.5-32.6-99.5-6.8-30-11.5-61.8-13.4-89.4-.6-9.5-.9-17.3-.9-23.6 46.4 38.2 97.8 46.4 143.8 53.8 38.9 6.2 75.6 12.1 103.9 35.4 25.5 21.1 46.7 49.7 59.6 80.6 14 33.4 15.9 66.9 12.7 100.7-180-63-264.5-170.5-264.5-170.5s72.5 125.2 252.3 200.8c-5.1 6.5-13.3 17.8-30 25.6z"
});

function SvgIosLeafOutline({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIosLeafOutline);
export default __webpack_public_path__ + "static/media/ios-leaf-outline.b17ff418.svg";
export { ForwardRef as ReactComponent };